import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_ASSET_TYPES } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type {
  AssetStatusOriginal,
  AssetTypeOriginal,
  OwnershipTypeOriginal,
  ReturnStatusOriginal,
  UserTypeOriginal,
} from './types'

type AssetTypes = {
  ownerships: { id: number; name: OwnershipTypeOriginal; textId: string }[]
  returnStatuses: { id: number; status: ReturnStatusOriginal; description: string }[]
  statuses: { id: number; status: AssetStatusOriginal; description: string }[]
  types: { id: number; type: AssetTypeOriginal; description: string }[]
  userTypes: { id: number; type: UserTypeOriginal; description: string }[]
}

export const getAssetTypes = async () => {
  const assetTypes = await get<AssetTypes>(API_ROUTE_ADMIN_ASSET_TYPES)
  const parsedAssetTypes = mapKeysToCamelCase(assetTypes)

  return parsedAssetTypes
}
